import { useEffect, useState } from 'react';
import { useLoadingStore } from 'store/loadingStore';
import LogoLoader from 'assets/images/logo_chrono_terra_simbolo.png';

interface PageLoaderProps {
  fullScreen?: boolean;
}

// ==============================|| PAGE LOADER ||============================== //
// fullScreen=true  → cubre toda la pantalla (AuthLayout / login)
// fullScreen=false → cubre solo el contenedor padre (MainLayout > pc-container)
//
// Se enciende con CUALQUIER llamada al API en vuelo (useLoadingStore.count > 0),
// no solo al cambiar de pantalla: por eso tiene que ser DISCRETO. Historia:
//   · v1: logo navy suelto → en el tema oscuro se perdía en el fondo.
//   · v2 (2026-10-05): disco grande + velo con desenfoque + texto → el usuario
//     lo vio "horrible" de tan grande, y aparecía en cada consulta.
//   · v3 (actual): indicador chico (64 px) con el símbolo ChronoTerra en un
//     disco claro y anillo cian; velo casi imperceptible, sin desenfoque, y solo
//     aparece si la carga tarda más de 300 ms (sin parpadeos en lo rápido).
// Va pegado (sticky) al centro de lo visible: el velo puede medir miles de px
// de alto en listas largas. Estilos: .sx-loader-* en terrasat-theme.scss.

const RETRASO_MS = 300;

export default function PageLoader({ fullScreen = false }: PageLoaderProps) {
  const cargando = useLoadingStore((s) => s.count > 0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!cargando) { setVisible(false); return; }
    const t = setTimeout(() => setVisible(true), RETRASO_MS);
    return () => clearTimeout(t);
  }, [cargando]);

  if (!visible) return null;

  return (
    <div
      className="sx-loader-velo"
      role="status"
      aria-label="Cargando"
      style={{ position: fullScreen ? 'fixed' : 'absolute' }}
    >
      <div className="sx-loader-centro">
        <div className="sx-loader">
          <span className="sx-loader-anillo" />
          <span className="sx-loader-disco">
            <img src={LogoLoader} alt="" />
          </span>
        </div>
      </div>
    </div>
  );
}
